(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundlecarousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ely-bundle-carousel')) {
  customElements.define('ely-bundle-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ely-bundles__track');
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev = this.querySelector('[data-eb-prev]');
      this.next = this.querySelector('[data-eb-next]');
      this.prev?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const card = this.track.querySelector('.ely-bundles__card');
      if (!card) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: (card.getBoundingClientRect().width + 10) * direction * (rtl ? -1 : 1), behavior: reduced ? 'instant' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      if (this.prev) this.prev.disabled = position <= 2;
      if (this.next) this.next.disabled = position >= max - 2;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
